"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CANCEL_REQUEST_MSG = void 0;
// eslint-disable-next-line import/prefer-default-export
exports.CANCEL_REQUEST_MSG = 'Cancel repeated request';
//# sourceMappingURL=definitions.js.map